import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  globalMessageHandler,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import useDictionaries from "features/dictionaries/useDictionaries";
import I18n from "i18n";
import { useMemo } from "react";
import {
  NotificationAddressItem,
  NotificationAddressOptions,
  getNotificationAddressService,
} from "./notificationAddressApi";

export interface UseNotificationAddressFormProps extends GridModalFormProps {}

export default function useNotificationAddressForm({
  id,
  afterSave,
  defaultValues,
}: UseNotificationAddressFormProps): UseFormReturnType<
  NotificationAddressItem,
  NotificationAddressOptions
> & { params?: any } {
  const params = useParams<"notificationAddress_id">();
  const scope = {};
  const service = getNotificationAddressService(scope);

  const form = useForm<NotificationAddressItem, NotificationAddressOptions>({
    id: params.notificationAddress_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "NotificationAddress",
    rules: {
      key: Validator.rule.string().required(),
    },
    afterSave,
    defaultValues: { send_email: true, ...defaultValues },
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: undefined,
  });
  const { dictionaries } = useDictionaries();

  const options = useMemo(() => {
    return {
      user_ids: dictionaries.users,
      key: [
        {
          value: "refund_admin",
          label: I18n.t(`NotificationAddress.options.key.refund_admin`),
        },
      ],
    };
  }, [dictionaries?.users]);

  return { ...form, params, options };
}
